export default "__VITE_ASSET__DjSuZP$y__"